import { traverse } from '@goodt-common/utils';
/* eslint-disable no-param-reassign */

/**
 * Fixes direct ElemGridLayout children overflow issue related to safari bug (@see #5463)
 * Applies 'min-height: 100%' style to child elements of ElemGridLayout parent
 * @effect elem
 * @param {import('@goodt-common/utils').AppEntityElem} elem
 * @param {import('@goodt-common/utils').AppEntityElem} parent
 */
const gridLayoutPatch = (elem, parent) => {
    if (parent == null || parent.type !== 'ElemGridLayout') {
        return;
    }
    const cssStyle = elem.props?.cssStyle ?? {};
    const height = parseInt(elem.props.height, 10);
    const heightStyle = parseInt(cssStyle.height, 10);

    if (Object.prototype.hasOwnProperty.call(cssStyle, 'min-height')) {
        return;
    }
    if (height === 0 || heightStyle === 0) {
        elem.props.cssStyle = { ...cssStyle, 'min-height': '100%' };
    }
};

/**
 * Patches page content
 * @effect content
 * @param {import('@goodt-common/utils').AppEntityElem[]} content
 */
export const patchPageContent = (content) => {
    const patches = [];
    traverse(content, 'children', (elem, parent) => patches.forEach((patch) => patch(elem, parent)));
};

/**
 * Patches page entity
 * @effect page
 * @param {import('./page').AppEntityPage} page
 */
export const patchPage = (page) => {
    patchPageContent(page.content);
};
